import React, { Fragment } from "react";
import Footer from "../components/Footer";

const Contact = () => {
    return (
        <Fragment>
            <div class="breadcumb-wrapper" style={{ background: "linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),  url('/assets/img/added/ban.jpg')" }} >
                <div class="container z-index-common">
                    <div class="breadcumb-content">
                        <h1 class="breadcumb-title">Contact Us</h1>
                        <div class="breadcumb-menu-wrap">
                            <ul class="breadcumb-menu">
                                <li><a href="index.html">Home</a></li>
                                <li>Contact</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <section class="space contact-box_wrapper">
                <div class="">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-4 col-md-6">
                                <div class="contact-box">
                                    <div class="contact-box_icon">
                                        <i class="fas fa-map-marked-alt"></i>
                                    </div>
                                    <h3 class="contact-box__title h5">Address</h3>
                                    <p class="contact-box__text"><a href="">1 Union Smruti. Near Patel Nagar. Ichhanath. Surat - 395007. Gujarat.</a></p>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6">
                                <div class="contact-box">
                                    <div class="contact-box_icon">
                                        <i class="fas fa-address-card"></i>
                                    </div>
                                    <h3 class="contact-box__title h5">Contact</h3>
                                    <ul class="contact-box_list">
                                        <li><a href="/">+91 997 441 4718</a></li>
                                        <li><a href="/">+353 1 903 8581</a></li>
                                        <li><a href="/">+1 909 389 6473</a></li>
                                    </ul>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6">
                                <div class="contact-box">
                                    <div class="contact-box_icon">
                                        <i class="fas fa-envelope"></i>
                                    </div>
                                    <h3 class="contact-box__title h5">Email us</h3>
                                    <ul class="contact-box_list">
                                        <li><a href="/">organictoursindia@gmail.com</a></li>
                                        <li><a href="/">himanshuchauhan4@gmail.com</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
           
            <div class="space bg-light">
                <div class="container">
                    <form class="ajax-contact" action="https://html.vecurosoft.com/mail.php" method="POST">
                        <div class="row justify-content-center text-center">
                            <div class="col-xxl-8 col-xl-6 col-lg-6 col-md-6">
                                <div class="title-area">
                                    <span class="sec-subtitle">Contact Us</span>
                                    <h2 class="sec-title h1">Get In Touch</h2>
                                    <p class="sec-text">We’d love to hear from you! Whether you have questions, need more information, or want to start planning your journey with us, feel free to reach out. Simply fill out the form below or email us at <a href="">organictoursindia@gmail.com</a>, and we’ll respond as soon as possible.</p>
                                </div>
                            </div>
                        </div>
                        <div class="row justify-content-center">
                            <div class="col-md-6 form-group">
                                <input type="text" placeholder="Enter Your First Name" name="fname" id="fname" class="form-control" />
                            </div>
                            <div class="col-md-6 form-group">
                                <input type="text" placeholder="Enter Your Last Name" name="lname" id="lname" class="form-control" />
                            </div>
                            <div class="col-md-6 form-group">
                                <input type="email" placeholder="Your Email" name="email" id="email" class="form-control" />
                            </div>
                            <div class="col-md-6 form-group">
                                <input type="number" placeholder="Phone No" name="number" id="number" class="form-control" />
                            </div>

                            <div class="form-group col-12">
                                <textarea placeholder="Write Your Comment" name="message" id="message" class="form-control"></textarea>
                            </div>
                            <div class="col-md-auto pt-lg-3">
                                <button class="vs-btn style4" type="submit">Send Message</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <Footer />
        </Fragment>
    );
}

export default Contact;